import { graphql, useStaticQuery } from 'gatsby';

export default function useSiteMetadata() {
  const meta = useStaticQuery(graphql`
    query siteMetdataQuery{
      site {
        siteMetadata {
          title
          description
          siteUrl
          shortName
          mainImage
          twitterUrl
          themeColor
          hideUnpublished
        }
      }
    }
  `);
  return meta.site.siteMetadata;
}
